import { MessageReceived, MessageSent } from "../../models/webSockets";

export abstract class AbstractSocketService {
  protected static instance: AbstractSocketService;
  protected messageListeners: Array<<T>(message: MessageReceived<T>) => void | Promise<void>>;

  /**
   * Get the singleton instance of the service (to be implemented by subclass as needed)
   */
  public static getInstance(): AbstractSocketService {
    throw new Error("getInstance() must be implemented in subclass");
  }

  /**
   * Subscribe a listener to socket messages
   */
  public subscribeListener<T>(messageListener: (message: MessageReceived<T>) => void | Promise<void>) {
    this.messageListeners.push(messageListener as <T>(message: MessageReceived<T>) => void | Promise<void>);
  }
  /**
   * Parse message and send to any subscribed listeners
   */
  protected handleMessage(message: string) {
    try {
      const parsedMessage = JSON.parse(message);
      for (const listener of this.messageListeners) {
        listener(parsedMessage);
      }
    } catch (err) {
      console.error('WebSocket could not parse message.', { message, err });
    }
  }

  /**
   * Send a message through the socket
   */
  public abstract sendMessage(message: string | Blob | ArrayBufferLike | ArrayBufferView<ArrayBufferLike> | MessageSent): void;

  /**
   * Broadcast a message to all clients (optionally excluding sender)
   */
  public abstract broadcastMessage<T>(payload: MessageReceived<T>, excludeSender?: boolean): Promise<void>;
}
